


































































import { Component, Model, Prop, Vue, Watch } from "vue-property-decorator";
import _ from "lodash";

/**
 * Utils
 */
import { getDateString, createDateString } from "@/utils/date-helpers";
import CalendarDayList from "@/components/calendar/components/CalendarDayList.vue";


interface VuetifyCalendar {
	prev: () => void;
	next: () => void;
}

/**
 * VueX Modules
 */

export interface CalendarModelInterface {
	month: number;
	year: number;
}


interface ComplexDate {
	date: string;
	time: string;
	year: number;
	month: number;
	day: number;
	hour: number;
	minute: number;
	weekday: number;
	hasDay: boolean;
	hasTime: boolean;
	past: boolean;
	present: boolean;
	future: boolean;
}


/**
 * Calendar page.
 */
@Component({
	components: {CalendarDayList}
})
export default class Calendar extends Vue {
	$refs!: {
		calendar: any;
	};

	/// Injections

	/// Attributes
	today: string = getDateString(new Date());
	focus: string = getDateString(new Date());
	start: ComplexDate | null = null;
	end: ComplexDate | null = null;

	// Props
	@Prop()
	onDayContextMenu!: (date: string, ev: PointerEvent) => void;

	/** V-MODEL */
	@Model("change")
	readonly externalModel!: CalendarModelInterface | null;

	internalModel: CalendarModelInterface | null = null;

	@Watch("internalModel")
	onInternalModelChanged(val: CalendarModelInterface) {
		this.$emit("change", val);
	}

	@Watch("externalModel")
	onExternalModelChanged(val: CalendarModelInterface) {
		this.internalModel = val;
	}

	/**
	 * Get an array of days in the current month.
	 * ex. [1, 2, ..., 31]
	 */
	get monthDays() {
		if (this.start && this.end) {
			return _.range(this.start.day, this.end.day + 1);
		}
		else {
			return [];
		}
	}

	/// Methods
	created() {
		this.focus = this.getDateStringByYearMonth(this.externalModel);
	}

	getDateStringByYearMonth(model: CalendarModelInterface | null) {
		if (model == null) {
			return getDateString(new Date());
		}

		return createDateString(model.year, model.month, 1);
	}

	/**
	 * Create a string 'yyyy-MM-{monthDay}' where yyyy-MM is the current focused month.
	 */
	createDateStringByDay(monthDay: number): string | null {
		if (this.start == null) {
			return null;
		}

		return createDateString(this.start.year, this.start.month, monthDay);
	}

	/**
	 * Even handler calendar@change.
	 */
	async updateRange({
		                  start,
		                  end
	                  }: {
		start: ComplexDate;
		end: ComplexDate;
	}) {

		this.start = start;
		this.end = end;

		this.internalModel = {
			month: this.start.month,
			year: this.start.year
		};
	}


	handleContextMenu(date: string, ev: PointerEvent) {
		if (this.onDayContextMenu) {
			ev.preventDefault();
			this.onDayContextMenu(date, ev);
		}
	}

	prev() {
		this.$refs.calendar.prev();
	}

	next() {
		this.$refs.calendar.next();
	}
}
